"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slideDown = void 0;
var defaults_1 = require("./defaults");
exports.slideDown = {
    enter: {
        keyframes: {
            transform: ["translate3d(0,100%,0)", "translate3d(0,0%,0)"],
        },
        options: { duration: defaults_1.defaultEnterDuration, easing: defaults_1.defaultEasingEnter },
    },
    exit: {
        keyframes: {
            transform: ["translate3d(0,0%,0)", "translate3d(0,100%,0)"],
        },
        options: { duration: defaults_1.defaultExitDuration, easing: defaults_1.defaultEasingExit },
    },
};
